var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.128 6.02786L9.6475 1.88559C9.36295 1.08946 8.23705 1.08946 7.9525 1.88559L6.47201 6.02786H1.76209C0.869631 6.02786 0.521388 7.18698 1.26608 7.67884L5.00038 10.1453L3.56032 14.1745C3.26927 14.9888 4.18225 15.7049 4.90383 15.2283L8.8 12.6549L12.6962 15.2283C13.4177 15.7049 14.3307 14.9888 14.0397 14.1745L12.5996 10.1453L16.3339 7.67884C17.0786 7.18698 16.7304 6.02786 15.8379 6.02786H11.128Z",
    fill: "#FFE400",
    stroke: "#FFE400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star_yellow.0e10b5a5c716c3475fd5fa577d791cd1.svg";
export { ForwardRef as ReactComponent };